import {HoistModel, managed, TaskObserver, XH} from '@xh/hoist/core';
import {action, observable} from '@xh/hoist/mobx';
import {asServerException, getDefaultOptions} from '../../../core/ServiceUtils';
import {GridModel} from '@xh/hoist/cmp/grid';

export class DataCheckDialogModel extends HoistModel {
    @observable accessor isOpen = false;
    apiTask = TaskObserver.trackLast();
    @managed gicsGrid = this.createGicsGrid();
    @managed betaGrid = this.createBetaGrid();
    @managed dividendGrid = this.createDividendGrid();

    @action open() {
        this.isOpen = true;
        this.gicsGrid.clear();
        this.betaGrid.clear();
        this.dividendGrid.clear();
        this.loadAsync();
    }

    @action close() {
        this.isOpen = false;
    }

    override async doLoadAsync() {
        try {
            const results = await XH.fetchJson({
                url: `${XH.getConf('svcApiUrl')}/DataConsistency`,
                method: 'GET',
                ...getDefaultOptions()
            }).linkTo(this.apiTask);

            this.gicsGrid.loadData(results.gicsChecks);
            this.betaGrid.loadData(results.betaChecks);
            this.dividendGrid.loadData(results.dividendChecks);
        } catch (e) {
            XH.handleException(asServerException(e), {title: 'Error running data checks'});
        }
    }

    private createGicsGrid(): GridModel {
        return new GridModel({
            store: {
                idSpec: 'ticker'
            },
            sortBy: 'ticker',
            contextMenu: null,
            emptyText: 'No issues',
            columns: [
                {
                    groupId: 'gics',
                    headerName: 'Invalid GICS',
                    headerAlign: 'center',
                    headerClass: 'data-check-dialog__column-group',
                    borders: false,
                    children: [
                        {field: 'ticker', width: 100},
                        {field: 'name', flex: 1},
                        {field: 'sector', width: 150},
                        {field: 'industry', width: 150}
                    ]
                }
            ]
        });
    }

    private createBetaGrid(): GridModel {
        return new GridModel({
            store: {
                idSpec: 'ticker'
            },
            sortBy: 'ticker',
            contextMenu: null,
            emptyText: 'No issues',
            columns: [
                {field: 'ticker', width: 100},
                {field: 'name', flex: 1},
                {field: 'beta', width: 150}
            ]
        });
    }

    private createDividendGrid(): GridModel {
        return new GridModel({
            store: {
                idSpec: 'ticker'
            },
            sortBy: 'ticker',
            contextMenu: null,
            emptyText: 'No issues',
            columns: [
                {field: 'ticker', width: 100},
                {field: 'name', flex: 1},
                {field: 'dividend', width: 150}
            ]
        });
    }
}
